import React, { useState } from 'react';
import { Row, Col, Tab, Nav } from 'react-bootstrap';
import { useAbility } from '@casl/react';
import MarkingsReportIndex from './MarkingsReportIndex';
import { Icon } from '../../components';
import { useSetTab } from '../../services/hooks';
import { AbilityContext } from '../../config/abilityContext';
import TotalizedAbsenceReportIndex from '../AbsenceReports/TotalizedAbsenceReportIndex';
import AttendanceRecordReportIndex from '../AttendanceReports/AttendanceRecordReportIndex';
import AttendanceDetailReportIndex from '../AttendanceDetailReport/AttendanceDetailReportIndex';
import ArrearsReportIndex from '../AttendanceReports/ArrearsReports/ArrearsReportIndex';
import AttendanceRecordTotalIndex from '../AttendanceReports/AttendanceRecordTotalIndex';
import OvertimeRecordReportIndex from '../OvertimeReports/OvertimeRecordReportIndex';
import OvertimeAgreementsReportIndex from './OvertimeAgreements/OvertimeAgreementsReportIndex';
import SimpleReportIndex from '../SimpleReports/SimpleReportIndex';
import OtherReportsSelector from './OtherReportsSelector';
import './Style.scss';
import WorkedSundayReportIndex from './WorkedSundays/WorkedSundayReportIndex';
import MissingTimeReportIndex from '../MissingTimeReport/MissingTimeReportIndex';
import ShiftSummaryReportIndex from '../ShiftSummaryReports/ShiftSummaryReportIndex';
import WorkedHolidayReportIndex from './WorkedHolidays/WorkedHolidayReportDataTable';

const CompanyReports = ({ location }) => {
  const [moreData, setMoreData] = useState(false);
  const ability = useAbility(AbilityContext);
  const setTab = () => {
    if (ability.can('export', 'Marking')) {
      return 'marking-report';
    }
    if (ability.can('export', 'ArrearsTotalizedReport')) {
      return 'arrears-report';
    }
    if (ability.can('export', 'OvertimeRecordReport')) {
      return 'overtime-report';
    }
    return null;
  };
  const canShowOtherReports =
    ability.can('export', 'AttendanceRecordReport') ||
    ability.can('export', 'AttendanceTotalReport') ||
    ability.can('export', 'AbsenceTotalizedReport') ||
    ability.can('index', 'OvertimeAgreementReport') ||
    ability.can('index', 'SimpleReport') ||
    ability.can('export', 'WorkedSundayReport') ||
    ability.can('export', 'ArrearsTotalizedReport');

  const [key, setKey] = useSetTab(setTab, location);

  return (
    <>
      <Row className="mt-2">
        <Col>
          <h2 className="mb-2 mt-2">Informes</h2>
        </Col>
      </Row>
      <Tab.Container id="company-settings-index.tabs" activeKey={key} onSelect={k => setKey(k)} mountOnEnter>
        <Nav variant="pills">
          {ability.can('export', 'Marking') && (
            <Nav.Item>
              <Nav.Link className="mb-1" eventKey="marking-report">
                <Icon icon="location" />
                Registro de Marca
              </Nav.Link>
            </Nav.Item>
          )}
          {ability.can('export', 'AttendanceDetailReport') && (
            <Nav.Item>
              <Nav.Link className="mb-1" eventKey="attendance-details">
                <Icon icon="location" />
                Detalle Asistencia
              </Nav.Link>
            </Nav.Item>
          )}
          {ability.can('export', 'MissingTimeReport') && (
            <Nav.Item>
              <Nav.Link className="mb-1" eventKey="missing-time-reports">
                <Icon icon="location" />
                Tiempo Faltante
              </Nav.Link>
            </Nav.Item>
          )}

          {ability.can('export', 'OvertimeRecordReport') && (
            <Nav.Item>
              <Nav.Link className="mb-1" eventKey="overtime-report">
                <Icon icon="location" />
                Reporte HHEE
              </Nav.Link>
            </Nav.Item>
          )}

          {canShowOtherReports && (
            <>
              <Nav.Item>
                <OtherReportsSelector selectedKey={key} setKey={setKey} ability={ability} />
              </Nav.Item>
            </>
          )}
        </Nav>
        <Tab.Content>
          {ability.can('export', 'Marking') && (
            <Tab.Pane eventKey="marking-report">
              <MarkingsReportIndex moreData={moreData} setMoreData={setMoreData} />
            </Tab.Pane>
          )}
          {ability.can('export', 'AttendanceRecordReport') && (
            <Tab.Pane eventKey="attendance-record-report">
              <AttendanceRecordReportIndex rrhh />
            </Tab.Pane>
          )}
          {ability.can('export', 'AttendanceDetailReport') && (
            <Tab.Pane eventKey="attendance-details">
              <AttendanceDetailReportIndex rrhh />
            </Tab.Pane>
          )}
          {ability.can('export', 'AttendanceDetailReport') && (
            <Tab.Pane eventKey="attendance-details-vertical">
              <AttendanceDetailReportIndex rrhh verticalTotals />
            </Tab.Pane>
          )}
          {ability.can('export', 'ArrearsTotalizedReport') && (
            <Tab.Pane eventKey="arrears-report">
              <ArrearsReportIndex rrhh />
            </Tab.Pane>
          )}
          {ability.can('export', 'MissingTimeReport') && (
            <Tab.Pane eventKey="missing-time-reports">
              <MissingTimeReportIndex rrhh resource="MissingTimeReport" />
            </Tab.Pane>
          )}
          {ability.can('export', 'DelayReport') && (
            <Tab.Pane eventKey="delay_report">
              <MissingTimeReportIndex rrhh resource="DelayReport" />
            </Tab.Pane>
          )}
          {ability.can('export', 'EarlyDeparturesReport') && (
            <Tab.Pane eventKey="early_departures_report">
              <MissingTimeReportIndex rrhh resource="EarlyDeparturesReport" />
            </Tab.Pane>
          )}
          {ability.can('export', 'AttendanceTotalReport') && (
            <Tab.Pane eventKey="attendance-record-total">
              <AttendanceRecordTotalIndex rrhh />
            </Tab.Pane>
          )}
          {ability.can('export', 'AbsenceTotalizedReport') && (
            <Tab.Pane eventKey="absence-report">
              <TotalizedAbsenceReportIndex rrhh />
            </Tab.Pane>
          )}
          {ability.can('export', 'OvertimeRecordReport') && (
            <Tab.Pane eventKey="overtime-report">
              <OvertimeRecordReportIndex rrhh />
            </Tab.Pane>
          )}
          {ability.can('index', 'OvertimeAgreementReport') && (
            <Tab.Pane eventKey="overtime-agreement-report">
              <OvertimeAgreementsReportIndex />
            </Tab.Pane>
          )}
          {ability.can('index', 'SimpleReport') && (
            <Tab.Pane eventKey="simple-report">
              <SimpleReportIndex rrhh moreData={moreData} setMoreData={setMoreData} />
            </Tab.Pane>
          )}
          {ability.can('export', 'WorkedSundayReport') && (
            <Tab.Pane eventKey="worked-sunday-report">
              <WorkedSundayReportIndex rrhh />
            </Tab.Pane>
          )}
          {ability.can('index', 'ShiftSummaryReport') && (
            <Tab.Pane eventKey="shift-summary-report">
              <ShiftSummaryReportIndex rrhh moreData={moreData} setMoreData={setMoreData} />
            </Tab.Pane>
          )}
          {ability.can('export', 'WorkedHolidayReport') && (
            <Tab.Pane eventKey="worked-holiday-report">
              <WorkedHolidayReportIndex rrhh />
            </Tab.Pane>
          )}
        </Tab.Content>
      </Tab.Container>
    </>
  );
};

export default CompanyReports;
